<app-header></app-header>
<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Inside Restaurant</ion-card-title>
      <ion-card-subtitle>Scan QR code to see Menu</ion-card-subtitle>
    </ion-card-header>
  
    <ion-card-content>
      <ion-button (click)="onScanClick()">
        <ion-icon slot="end" name="scan-circle-outline"></ion-icon>
        Scan
      </ion-button>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Want to view Special Menus</ion-card-title>
      <ion-card-subtitle>
        <ion-label (click)="navigateToHome()" routerLink="/customer/home" class="cursor-pointer">
          Select Restaurant and Branch to view Menu
        </ion-label>
      </ion-card-subtitle>
    </ion-card-header>
  
    <ion-card-content>
      
    </ion-card-content>
  </ion-card>
</ion-content>

